import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { blogs } from '../data/blogs';
import '../styles.css';

function BlogDetail() {
  const { id } = useParams();
  const post = blogs.find(b => b.id === Number(id));

  // Message si l'article n'est pas trouvé
  if (!post) {
    return (
      <div style={{ padding: '150px', color: 'white', textAlign: 'center', backgroundColor: '#0b0b13', minHeight: '100vh' }}>
        <h2>Article introuvable...</h2>
        <Link to="/" style={{ color: '#ec008c' }}>Retour à l'accueil</Link>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: '#0b0b13', color: 'white', minHeight: '100vh', paddingBottom: '100px' }}>
      
      {/* 1. IMAGE D'EN-TÊTE GÉANTE (Style JVC) */}
      <div style={{ height: '60vh', position: 'relative', overflow: 'hidden' }}>
        <img 
          src={post.image} 
          alt="" 
          style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.4 }} 
        />
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: '60px 20px', background: 'linear-gradient(to top, #0b0b13, transparent)' }}>
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            <span style={{ color: '#ec008c', fontWeight: 'bold', textTransform: 'uppercase' }}>{post.category}</span>
            <h1 style={{ fontSize: '3.5rem', margin: '15px 0', lineHeight: '1.1', fontWeight: '900' }}>{post.title}</h1>
            <p style={{ opacity: 0.6 }}>Par {post.author} • {post.date}</p>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '900px', margin: '40px auto', padding: '0 20px' }}>
        
        {/* BOUTON RETOUR DYNAMIQUE */}
        <Link to={`/game/${post.gameId}`} style={{ color: '#ec008c', textDecoration: 'none', fontWeight: 'bold' }}>
          ← Retour à la fiche du jeu
        </Link>
        
        {/* 2. INTRODUCTION EN ITALIQUE */}
        <p style={{ fontSize: '1.4rem', lineHeight: '1.6', color: '#fff', borderLeft: '4px solid #ec008c', paddingLeft: '25px', margin: '40px 0', fontStyle: 'italic' }}>
          {post.intro}
        </p>

        {/* 3. BOUCLE POUR CHAQUE SECTION (Texte + Image) */}
        {post.sections?.map((sec, index) => (
          <div key={index} style={{ marginBottom: '60px' }}>
            <h2 style={{ fontSize: '2.2rem', marginBottom: '25px', color: '#00ffcc', fontWeight: '800' }}>
              {sec.subtitle}
            </h2>
            <p style={{ fontSize: '1.2rem', lineHeight: '1.9', opacity: 0.8, marginBottom: '30px' }}>
              {sec.text}
            </p>
            
            {/* Affichage de l'image de la section si elle existe */}
            {sec.sectionImage && (
              <div style={{ textAlign: 'center', margin: '40px 0' }}>
                <img 
                  src={sec.sectionImage} 
                  alt={sec.imageCaption} 
                  style={{ width: '100%', borderRadius: '20px', boxShadow: '0 15px 50px rgba(0,0,0,0.6)' }} 
                />
                <p style={{ fontSize: '1rem', opacity: 0.5, marginTop: '15px', fontStyle: 'italic' }}>
                  {sec.imageCaption}
                </p>
              </div>
            )}
          </div>
        ))}

        {/* 4. LE VERDICT FINAL ET POINTS FORTS */}
        <div style={{ background: '#161625', borderRadius: '25px', padding: '50px', marginTop: '80px', border: '1px solid #222' }}>
          <h2 style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '30px' }}>Le Bilan Final</h2>
          <p style={{ fontSize: '1.3rem', textAlign: 'center', marginBottom: '50px', opacity: 0.9, lineHeight: '1.6' }}>
            {post.verdict}
          </p>
          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
            {/* Points Positifs */}
            <div style={{ background: 'rgba(0, 255, 204, 0.05)', padding: '30px', borderRadius: '15px', border: '1px solid rgba(0, 255, 204, 0.1)' }}>
              <h4 style={{ color: '#00ffcc', marginBottom: '20px', fontSize: '1.2rem' }}>✅ LES PLUS</h4>
              <ul style={{ paddingLeft: '20px' }}>
                {post.pros?.map((p, i) => <li key={i} style={{ marginBottom: '12px', opacity: 0.8 }}>{p}</li>)}
              </ul>
            </div>
            {/* Points Négatifs */}
            <div style={{ background: 'rgba(236, 0, 140, 0.05)', padding: '30px', borderRadius: '15px', border: '1px solid rgba(236, 0, 140, 0.1)' }}>
              <h4 style={{ color: '#ec008c', marginBottom: '20px', fontSize: '1.2rem' }}>❌ LES MOINS</h4>
              <ul style={{ paddingLeft: '20px' }}>
                {post.cons?.map((c, i) => <li key={i} style={{ marginBottom: '12px', opacity: 0.8 }}>{c}</li>)}
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default BlogDetail;